angular
  .module("datiFornitore.components", [])
  .component("accordionDatiFornitore", {
    templateUrl:
      "ng/components/censimentoAnagFornitore/accordionDatiFornitore/accordionDatiFornitore.view.html",
    controllerAs: "datiFornitoreCtrl",
    bindings: {
      model: "=",
      exportValidationComponent: "&",
    },
    controller: function (
      $transactionFactory,
      $typeDomainService,
      es6Factory,
      $rootScope,
      $timeout,
      $scope,
      validationService,
      RiUserG,
      Sede,
      $giuridicVersion
    ) {
      var self = this;

      self.$onInit = function () {
        self.$giuridicVersion = $giuridicVersion;
        var riUserG = $transactionFactory.get();
        if (typeof riUserG == "string") {
          self.model.fornitore.cf = riUserG;
        } else {
          self.datiFornitore = RiUserG.build(riUserG);
          for (var key in self.model.fornitore) {
            self.model.fornitore[key] = self.datiFornitore[key];
          }
        }
        populateLegalStatus();
        getListOfProv();
        if (
          self.datiFornitore &&
          self.datiFornitore.sedeLegale &&
          !self.datiFornitore.sedeLegale.numeroCivico
        ) {
          self.ncCervedAbsent = true;
        }
        if (self.datiFornitore) {
          if (self.datiFornitore.formaGiuridica) {
            self.getSaeByLegalStatus(self.datiFornitore.formaGiuridica);
          }
          if (self.datiFornitore.sae) {
            self.getRaeBySae(self.datiFornitore.sae);
          }
        }
        self.codiceFiscaleOk = true;
        validateComponent();
        self.handleChange()
      };

      self.handleChange = function (value, property) {
        switch (property) {
          case "formaGiuridica":
            self.getSaeByLegalStatus(value);
            if (!$giuridicVersion.checkIfInd(value)) {
              self.model.fornitoreInd = null;
            } else {
              self.model.fornitoreInd.cf = self.model.fornitore.cf;
            }
            break;
          case "sae":
            self.getRaeBySae(value);
            break;
          case "numeroCivico":
            self.datiFornitore.sedeLegale.numeroCivico = null;
            self.model.fornitore.sedeLegale.numeroCivico = value;
        }
        if (
          self.model.fornitoreInd &&
          (self.model.fornitoreInd.cognome || self.model.fornitoreInd.nome)
        ) {
          $timeout(function () {
            self.codiceFiscaleOk = validationService.checkCfWithName(
              self.model.fornitore.cf,
              self.model.fornitoreInd.cognome,
              self.model.fornitoreInd.nome
            );
          }, 500);
        }
        validateComponent();
      };

      var validateComponent = function () {
        $timeout(function () {
          if ($scope.CervedForm) {
            var formValidity =
              self.model.fornitoreInd &&
                self.model.fornitoreInd.nome &&
                self.model.fornitoreInd.cognome
                ? $scope.CervedForm.$valid && self.codiceFiscaleOk
                : $scope.CervedForm.$valid;
            self.exportValidationComponent({
              valid: formValidity,
            });
          }
        }, 500);
      };

      self.dropdown = {
        legalStatuses: [],
        sae: [],
        rae: [],
      };

      var populateLegalStatus = function () {
        self.legalStatusLoader = true;

        $typeDomainService
          .getAllLegalStatuses()
          .then(function (response) {
            self.dropdown.legalStatuses = response;
            self.legalStatusLoader = false;
          })
          .catch(function (error) {
            self.legalStatusLoader = false;
            console.log(error);
          });
      };

      self.getSaeByLegalStatus = function (legalStatus) {
        self.emptySae = false;
        self.saeLoader = true;

        if (legalStatus == "PEF") {
          self.model.fornitore.piva = null;
        }

        if (
          $giuridicVersion.checkIfInd(legalStatus) &&
          es6Factory.isNumeric(self.model.fornitore.cf)
        ) {
          self.showErrorFormaGiuridica = true;
        } else {
          self.showErrorFormaGiuridica = false;
        }

        $typeDomainService
          .getSaeByLegalStatus(legalStatus)
          .then(function (saeList) {
            self.dropdown.sae = saeList;
            self.saeLoader = false;
            if (!saeList.length) {
              self.emptySae = true;
            }
          })
          .catch(function (err) {
            console.log(err);
            self.saeLoader = false;
          });
      };

      self.getRaeBySae = function (sae) {
        self.raeLoader = true;

        $typeDomainService
          .getRaeBySae(sae)
          .then(function (raeList) {
            self.dropdown.rae = raeList;
            self.raeLoader = false;
          })
          .catch(function (err) {
            console.log(err);
            self.raeLoader = false;
          });
      };

      var getListOfProv = function () {
        self.listaProvince = $rootScope.comuniMap
          .map(function (comune) {
            return comune.sigla;
          })
          .filter(function (siglaComune) {
            return siglaComune != "";
          })
          .sort()
          .reduce(function (result, nextItem) {
            return result.includes(nextItem) ? result : result.concat(nextItem);
          }, []);
      };
    },
  });
